export const SPONSORSHIP_TIERS = [
  { id: 'title', label: 'Title', description: 'Premier branding across contest hub, hero placements, and primary video credits' },
  { id: 'gold', label: 'Gold', description: 'High-visibility logos on contest cards and training content groups' },
  { id: 'silver', label: 'Silver', description: 'Category-level branding and featured mentions' },
  { id: 'bronze', label: 'Bronze', description: 'Supporting partner strip and opportunity listings' },
  { id: 'supporting', label: 'Supporting', description: 'Community partner recognition on select placements' },
  { id: 'flexible', label: 'Flexible / Discuss', description: 'Tell us your goals — tier matched to budget and competition' },
] as const;

export const SPONSOR_BUDGET_BANDS = [
  { id: 'exploratory', label: 'Exploratory — learning about options' },
  { id: 'under_50k', label: 'Under INR 50K / local equivalent' },
  { id: '50k_200k', label: 'INR 50K – 2L / regional campaigns' },
  { id: '200k_500k', label: 'INR 2L – 5L / multi-contest packages' },
  { id: '500k_plus', label: 'INR 5L+ / title & series partnerships' },
  { id: 'flexible', label: 'Flexible — discuss with partnerships team' },
] as const;

export const SPONSOR_INTEREST_CATEGORIES = [
  { id: 'contest', label: 'Contest sponsorship', icon: 'contest' },
  { id: 'training_video', label: 'Training video content', icon: 'video' },
  { id: 'content_series', label: 'Learning & rubric content', icon: 'content' },
  { id: 'tournament', label: 'Tournaments & leagues', icon: 'tournament' },
  { id: 'new_format', label: 'New format pilots', icon: 'format' },
] as const;

export const SPONSOR_GEOGRAPHY_OPTIONS = [
  'India',
  'South Asia',
  'Asia Pacific',
  'Europe',
  'North America',
  'Middle East',
  'Africa',
  'Global',
] as const;

/** Phase 1: no public pricing page; flip to true when ready to publish packages */
export const SPONSOR_PUBLIC_PRICING_ENABLED = false;

export type SponsorshipTierId = (typeof SPONSORSHIP_TIERS)[number]['id'];
export type SponsorBudgetBandId = (typeof SPONSOR_BUDGET_BANDS)[number]['id'];
export type SponsorInterestCategoryId = (typeof SPONSOR_INTEREST_CATEGORIES)[number]['id'];

export interface SponsorshipOpportunity {
  id: string;
  title: string;
  description?: string;
  opportunityType: string;
  sport?: string | null;
  contestCategory?: string | null;
  sponsorshipTier?: string | null;
  slotsAvailable?: number;
  estimatedReach?: string | null;
  geography?: string | null;
  status?: string;
}

export interface FeaturedSponsor {
  id: string;
  name: string;
  logoUrl?: string;
  websiteUrl?: string;
  industry?: string;
  country?: string;
  preferredTier?: string;
}

export const getTierLabel = (tierId?: string | null) =>
  SPONSORSHIP_TIERS.find((t) => t.id === tierId)?.label || tierId || 'Partner';

export const getBudgetLabel = (bandId?: string | null) =>
  SPONSOR_BUDGET_BANDS.find((b) => b.id === bandId)?.label || bandId || '';

export const getOpportunityTypeLabel = (type?: string) => {
  const map: Record<string, string> = {
    contest: 'Contest',
    training_video: 'Training video',
    content_series: 'Content series',
    tournament: 'Tournament',
    new_format: 'New format',
  };
  return map[String(type || '')] || type || 'Partnership';
};

export const tierGradient = (tier?: string | null) => {
  switch (tier) {
    case 'title':
      return 'linear-gradient(135deg, #f59e0b 0%, #d97706 45%, #92400e 100%)';
    case 'gold':
      return 'linear-gradient(135deg, #fde68a 0%, #f59e0b 55%, #b45309 100%)';
    case 'silver':
      return 'linear-gradient(135deg, #e2e8f0 0%, #94a3b8 55%, #64748b 100%)';
    case 'bronze':
      return 'linear-gradient(135deg, #fed7aa 0%, #ea580c 55%, #9a3412 100%)';
    default:
      return 'linear-gradient(135deg, #6366f1 0%, #4f46e5 55%, #312e81 100%)';
  }
};
